import React from 'react';
import parse from 'html-react-parser';
import { Tooltip } from 'antd';

function LabelToolTip({ label, tip }) {
  return (
    <Tooltip placement="topLeft" title={parse(tip)}>
      {parse(label)}
    </Tooltip>
  );
}

export default LabelToolTip;
